export default class Paginate {
  constructor(htParams) {
    this.welPaginate = htParams.welPaginate;
    this.sTlcode = htParams.sTlcode;
  }

  init(htInfo) {
    if (htInfo.onClickNumber) {
      this.onClickNumber = htInfo.onClickNumber;
    }
    this.setEvent();
  }

  setEvent() {
    this.welPaginate.on('click', '[data-role=paginate-num]', e => {
      this.onClickNumber(e);
    });
  }

  onClickNumber(e) {
    e.preventDefault();
  }

  update(htInfo) {
    this.render(htInfo);
  }

  /**
   * @param {object} htInfo
   *  {{
   *      nPageOnBlock 한 블럭에 페이지가 몇 개 들어가는지
   *      nActivatePage 몇 번째 페이지를 활성화 표시할지
   *      nTotalArticle 아티클의 총 갯수
   *      nArticleOnPage 한 페이지에 아티클의 몇 개 표시되는지
   *  }}
   */
  render(htInfo) {
    const htRefine = htInfo;
    let nPage = 0;
    htRefine.nFullPage = Math.ceil(
      htRefine.nTotalArticle / htRefine.nArticleOnPage
    );
    htRefine.nPageBlock =
      Math.ceil(htRefine.nActivatePage / htRefine.nPageOnBlock) - 1;
    if (htRefine.nFullPage === 0) {
      return;
    }
    let sHtml = '<div class="pagination">';
    if (htRefine.nActivatePage !== 1) {
      sHtml = `
                ${sHtml}
                <a class="first_page" href="#" title="맨 앞 페이지" data-role="paginate-num" data-num="1" data-tlarea="${
                  this.sTlcode
                }" data-tlord="1">맨 앞 페이지</a>
                <a class="prev_page" href="#" title="이전 페이지" data-role="paginate-num" data-num="${htRefine.nActivatePage -
                  1}" data-tlarea="${
        this.sTlcode
      }" data-tlord="2">이전 페이지</a>
            `;
    }
    for (let i = 1; i <= htRefine.nPageOnBlock; i += 1) {
      nPage = htRefine.nPageBlock * htInfo.nPageOnBlock + i;
      if (nPage <= htRefine.nFullPage) {
        sHtml = `
                    ${sHtml}
                    <a href="#" ${
                      nPage === htRefine.nActivatePage
                        ? 'class="crnt_page"'
                        : ''
                    } data-role="paginate-num" data-num="${nPage}" data-tlarea="${
          this.sTlcode
        }" data-tlord="3">${nPage}</a>
                `;
      }
    }
    if (htRefine.nActivatePage !== htRefine.nFullPage) {
      sHtml = `
                ${sHtml}
                <a class="next_page" href="#" title="다음 페이지" data-role="paginate-num" data-num="${htRefine.nActivatePage +
                  1}" data-tlarea="${
        this.sTlcode
      }" data-tlord="4">다음 페이지</a>
                <a class="last_page" href="#" title="맨 끝 페이지" data-role="paginate-num" data-num="${
                  htRefine.nFullPage
                }" data-tlarea="${this.sTlcode}" data-tlord="5">맨 끝 페이지</a>
            `;
    }
    sHtml = `${sHtml}</div>`;
    this.welPaginate.html(sHtml);
  }
}
